<template>
  <div class="row" ref="add2FaProtocol">
    <div class="col-12">
      <div class="form-group">
        <div class="row align-items-center">
          <div class="col-8 pe-0">
            <k-input
              id="newProtocolInput"
              :label="this.typeOfProtocol"
              :placeholder="this.typeOfProtocol"
              v-model="newProtocolValue"
              :disabled="!codeInputDisabled"
              class="mobile-text"
            />
          </div>
          <div class="col-4">
            <k-button
              class="btn btn-success btn-sm w-100 mobile-button"
              type="button"
              @click="getCode"
            >Get code</k-button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="form-group">
        <k-input
          id="verificationCodeInput"
          type="text"
          v-model="verificationCode"
          :label="'Verification Code'"
          placeholder="Verification Code"
          :disabled="this.codeInputDisabled"
          class="mobile-text"
        />
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import AuthService from "../services/auth-service";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  name: "add-2fa-protocol",
  props: {
    protocol: String
  },
  data() {
    return {
      verificationCode: "",
      newProtocolValue: "",
      codeInputDisabled: true
    }
  },
  computed: {
    typeOfProtocol() {
      if (this.protocol === "phone") {
        return "Mobile Number";
      }
      else {
        return "Email";
      }
    },
    defaultEmail() {
      return store.getters.isAdmin ? "" : store.getters.email;
    },
    defaultPhone() {
      return store.getters.isAdmin ? "" : store.getters.phoneNumber;
    }
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      if (this.protocol === "phone" && this.defaultPhone) {
        this.newProtocolValue = this.defaultPhone;
      } else if (this.protocol === "email" && this.defaultEmail) {
        this.newProtocolValue = this.defaultEmail;
      }
    },
    async getCode() {
      if (this.newProtocolValue.trim() === "") {
        switch (this.protocol) {
           case "phone":
             toast.error("Please enter your mobile number.");
             return;
           case "email":
             toast.error("Please enter your email address.");
             return;
           default:
             toast.error("Invalid 2FA type");
             return;
        }
      }
      await AuthService.Request2FAProtection(this.protocol, this.newProtocolValue)
        .then((response) => {
          if (response.data) {
            this.codeInputDisabled = false;
            toast.clear();
            toast.success("Code sent successfully");
          } else {
            this.showAlertGetCode()
          }
        }).catch(this.showAlertGetCode);
    },
    async submitCode() {
      await AuthService.Apply2FAProtection(this.verificationCode)
        .then((response) => {
          if (response.data) {
            toast.clear();
            toast.success("Successful");
            if (store.getters.userID != null && store.getters.userID > 0) {
              this.$parent.click2fa();
            } else {
              this.$parent.$parent.backToBusinessSetup();
            }
          } else {
            this.showAlertSubmitCode()
          }
      }).catch(this.showAlertSubmitCode);
    },
    showAlertGetCode() {
      toast.clear();
      toast.error("Error sending code. Please try again.");
    },
    showAlertSubmitCode() {
      toast.clear();
      toast.error("Code is incorrect.");
    }
  }
};
</script>
